import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function confirmWalletOwnership() {
  try {
    const address = ParcisionCookies.get("address");
    const variables = {
      address,
    };

    const query = gql`
      query MyQuery($address: String!) {
        confirmPeraWalletOwnership(address: $address) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.confirmPeraWalletOwnership.message;
  } catch (error) {
    toast.error("Failed to confirm opt-in contract");
    sentryWrappedException(error);
    throw error;
  }
}
